module.exports = __webpack_public_path__ + "media/1c505bf1.pdf";